// Generated by ts-to-zod
import { z } from 'zod';

export const executionResultSchema = z.union([
  z.literal('success'),
  z.literal('failure'),
  z.literal('partial_success'),
]);

export const actionExecutionResultSchema = z.object({
  actionId: z.string().nullable(),
  actionType: z.string(),
  success: z.boolean(),
  payload: z.record(z.unknown()),
  error: z.string().optional(),
});

export const ruleExecutionLogSchema = z.object({
  ruleId: z.number(),
  ruleName: z.string(),
  queueId: z.number(),
  annotationId: z.number(),
  requestId: z.string(),
  createdAt: z.string(),
  triggerEvent: z.string(),
  triggerCondition: z.string(),
  triggerConditionResults: z.array(z.boolean()),
  triggerConditionValues: z.array(z.record(z.string())).nullable(),
  triggerMatch: z.boolean().optional(),
  executionResult: executionResultSchema,
  executionError: z.string().optional().nullable(),
  actions: z.array(z.array(actionExecutionResultSchema).nullable()).nullable(),
});
